import { IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonImg, IonInput, IonItem, IonLabel, IonMenuButton, IonModal, IonNote, IonPage, IonRadio, IonRadioGroup, IonRow, IonSelect, IonSelectOption, IonText, IonTextarea, IonTitle, IonToolbar, useIonRouter, useIonViewDidEnter } from '@ionic/react';
import { add, addCircleOutline, chevronBackOutline, navigateOutline } from 'ionicons/icons';
import React, { useEffect, useRef, useState } from 'react';
import { useAppContext } from '../AppProvider';
import PlaceCreateModal from './PlaceCreateModal'
import Alert from '@mui/material/Alert';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { AlertTitle } from '@mui/material';

const TrailCreate: React.FC = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [routeType, setRouteType] = useState<string>('LOOP')
    const [endPlaceDisabled, setEndPlaceDisabled] = useState<boolean>(true);
    const [newStartPlaceIsAvailable, setNewStartPlaceIsAvailable] = useState<boolean>(true);
    const [newEndPlaceIsAvailable, setNewEndPlaceIsAvailable] = useState<boolean>(true);
    const [newStartPlaceIsOpen, setNewStartPlaceIsOpen] = useState<boolean>(false);
    const [newEndPlaceIsOpen, setNewEndPlaceIsOpen] = useState<boolean>(false);
    const [startPlaceTokenVal, setStartPlaceTokenVal] = useState<string>('');
    const [endPlaceTokenVal, setEndPlaceTokenVal] = useState<string>('');

    const { networkStatus, getAppStatus, authKey, authenticateMember, authorizedMember, limits, profiles, settings, timezonesIANA, textLogoLoaded, fadeInTextLogo, SWFullHorizLogo, SWTextDarkLogo, getTimezonesIANA, userIANATimezone, startPlaces, endPlaces, setEndPlaces, getPlaces, showToast } = useAppContext();

    const startPlaceRef = useRef<any>();
    const endPlaceRef = useRef<any>();
    
    const router = useIonRouter();

    //
    // Authenticate Member
    //
    useIonViewDidEnter(() => { 
        const authenticate = async () => {  
            const appstat = await getAppStatus();
            if (!networkStatus && appstat === 'No') {
                router.push('/connection', 'forward');
            } else {
                const authenticated = await authenticateMember();         
                if(!authenticated || authenticated.mt == '') router.push('/login', 'forward');
            }
        };
        authenticate();
    }); 


    useEffect(() => {
        if (limits.routes > 0) {
            const fetchData = async () => {
                await getPlaces(authorizedMember.memberToken, limits.places);
                if (timezonesIANA.length === 0) await getTimezonesIANA();
                setLoading(false);
            }
            fetchData();
        }
    }, [authorizedMember, limits]);


    const toggleType = (e: any) => {
        setRouteType(e.detail.value);
        if(e.detail.value == 'LOOP') {
            setEndPlaces(startPlaces);
            endPlaceRef.current.value = startPlaceRef.current.value;
            setNewEndPlaceIsOpen(false);
        } else {
            let eps:any = [];
            startPlaces.forEach((item:any, index:number, arr:any) => {
                if(item.placeToken != startPlaceRef.current.value) eps.push(item);
            });
            setEndPlaces(eps);
        }       
        
        setEndPlaceDisabled(e.detail.value == 'LOOP');
    };

    const syncEndPlace = (e: any) => {
        let eps:any = [];
        setStartPlaceTokenVal(e.detail.value);
        startPlaces.forEach((item:any, index:number, arr:any) => {
            if(endPlaceDisabled || item.placeToken != startPlaceRef.current.value) eps.push(item);
        });
        setEndPlaces(eps);

        if(endPlaceDisabled) {            
            endPlaceRef.current.value = e.detail.value;
        } else if(endPlaceRef.current.value == startPlaceRef.current.value) {
            //endPlaceRef.current.value = '';
        }
    };

    const handleEndPlaceChange = (e: any) => {
        setEndPlaceTokenVal(e.detail.value);
    };

    const insertRoute = async (e: any) => {
        e.preventDefault();
        const form = e.target; 
        const formName = form.name;
        const btn: any = document.getElementById(formName + 'Submit');
        btn.innerHTML = 'Saving...';
        btn.setAttribute('disabled', '');
        const formData = new FormData(form);
        formData.append('mt', authKey.mt);
        
        try {
            const response = await fetch('https://api.besolowise.com/routes/insert-trail/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            
            if(response.ok) {
                const obj = await response.json(); 
                if(obj.success) router.push('/account/trail/edit/' + obj.rt, 'back');
                else {
                    btn.innerHTML = 'Save';
                    btn.removeAttribute('disabled');
                    showToast({
                        message: 'Error: ' + obj.message,
                        duration: 5000,
                        color: 'danger',
                    });
                }
            } else {
                btn.innerHTML = 'Save';
                btn.removeAttribute('disabled');
                showToast({
                    message: 'Response Error',
                    duration: 2000,
                    color: 'danger',
                });
            } 
        } catch(error) {
            showToast({
                message: 'Connection Error: Couldn\'t create this Trail. ' + error + '. Try again.',
                duration: 3000,
                color: 'danger',
                position: 'bottom'
            });
        }       
    };


    const openNewStartPlaceModal = () => {
        if (!newStartPlaceIsOpen && profiles.places + 1 == limits.places) setNewEndPlaceIsAvailable(false); else setNewEndPlaceIsAvailable(true);
        setNewStartPlaceIsOpen(!newStartPlaceIsOpen);
        setStartPlaceTokenVal('');
        startPlaceRef.current.disabled = !newStartPlaceIsOpen;         
    };


    const openNewEndPlaceModal = () => {
        if (!newEndPlaceIsOpen && profiles.places + 1 == limits.places) setNewStartPlaceIsAvailable(false); else setNewStartPlaceIsAvailable(true);
        setNewEndPlaceIsOpen(!newEndPlaceIsOpen);
        setEndPlaceDisabled(!newEndPlaceIsOpen);
        setEndPlaceTokenVal('');
    };

    
    const insertPlace = async (e: any) => {
        e.preventDefault();
        const form = e.target; 
        const formName = form.name;
        const btn: any = document.getElementById(formName + 'Submit');
        btn.innerHTML = 'Saving...';
        btn.setAttribute('disabled', '');
        const formData = new FormData(form);
        formData.append('mt', authKey.mt);
        
        try {
            const response = await fetch('https://api.besolowise.com/places/insert/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            
            if(response.ok) {
                const obj = await response.json(); 
                
                if(obj.success) {
                    await getPlaces(authKey.mt, limits.places);
                    if(newStartPlaceIsOpen) {
                        setStartPlaceTokenVal(obj.pt);
                        setNewStartPlaceIsOpen(false);
                    } else if(newEndPlaceIsOpen) {
                        setEndPlaceTokenVal(obj.pt);
                        setNewEndPlaceIsOpen(false);
                    }                        
                } else {
                    btn.innerHTML = 'Save';
                    btn.removeAttribute('disabled');
                    showToast({
                        message: 'Error: ' + obj.message,
                        duration: 5000,
                        color: 'danger',
                    });
                }
            } else {
                btn.innerHTML = 'Save';
                btn.removeAttribute('disabled');
                showToast({
                    message: 'Response Error',
                    duration: 2000,
                    color: 'danger',
                });
            } 
        } catch(error) {
            showToast({
                message: 'Connection Error: Couldn\'t create this place. ' + error + '. Try again.',
                duration: 3000,
                color: 'danger',
                position: 'middle'
            });
        }       
    }; 

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot='start'>
                        <IonButton color={'tertiary'} routerLink='/account/routes'>Routes</IonButton>
                    </IonButtons>
                    <IonTitle><IonImg className={textLogoLoaded ? 'fade-in' : 'fade-out'} src={settings.theme == '1' ? SWTextDarkLogo : SWFullHorizLogo} onIonImgDidLoad={fadeInTextLogo}></IonImg></IonTitle>
                    <IonButtons slot='end'>
                        <IonMenuButton color={'tertiary'} />
                    </IonButtons>
                </IonToolbar>                
            </IonHeader>
            <IonContent className="ion-padding account-content-bg">
                <IonGrid>
                    <IonRow>
                        <IonCol size='12'>
                            <h1><IonIcon color={'secondary'} icon={navigateOutline}></IonIcon> New Trail<br /><span>Save details for your favorite trails </span></h1>
                        </IonCol>
                    </IonRow>
                </IonGrid>
                
                {!loading && profiles?.routes >= limits?.routes &&
                    <IonCard>
                        <IonCardHeader>
                            <IonCardTitle className='ion-margin-bottom ion-text-center' color={'tertiary'}>
                                You've reached the limit of Routes for your current plan.
                            </IonCardTitle>
                        </IonCardHeader>
                        <IonCardContent>
                            <p className='ion-margin-bottom ion-text-center'>
                                You can add more Routes by upgrading to a SoloWise Premium plan. 
                            </p>
                            <p className='ion-margin-bottom ion-text-center'>                            
                                <IonButton className='ion-margin' color={'secondary'} routerLink='/account/plans' routerDirection='forward'><IonIcon icon={addCircleOutline} slot='start'></IonIcon> Upgrade Now</IonButton>
                            </p>
                        </IonCardContent>
                    </IonCard>
                } 

                {!loading && profiles?.routes < limits?.routes &&
                <IonCard>
                    <IonCardContent>
                        <form name='routeForm' onSubmit={insertRoute}>
                            <IonGrid>

                                <IonRow>
                                    <IonCol size='12'>
                                        <IonLabel color={'dark'}><b>Trail Name or Number</b> <em className='required'>Required</em></IonLabel>
                                    </IonCol>
                                    <IonCol size='12'>
                                        <IonInput autoCapitalize='sentences' className='ion-margin-bottom' fill='outline' name='routeName' placeholder='' type='text' maxlength={50}></IonInput>                                        
                                    </IonCol>                                  
                                </IonRow>

                                <IonRow>
                                    <IonCol size='12'>
                                        <IonLabel color={'dark'}><b>Type of Course</b> <em className='required'>Required</em></IonLabel>
                                    </IonCol>
                                </IonRow>

                                <IonRow className='ion-margin-bottom'>
                                    <IonCol size='12'>
                                        <IonRadioGroup className='ion-margin-bottom' name='routeType' onIonChange={toggleType} value={routeType}>
                                            <IonRow>
                                                <IonCol size='12' sizeSm='6'>
                                                    <IonItem lines='none'>
                                                        <IonRadio color={'secondary'} justify="start" key={1} labelPlacement="end" value='LOOP'>
                                                        Loop / Out-and-back<br />
                                                        <IonNote>Starts and ends at the same trailhead</IonNote>
                                                        </IonRadio>
                                                    </IonItem>
                                                </IonCol>
                                                <IonCol size='12' sizeSm='6'>
                                                    <IonItem lines='none'>
                                                        <IonRadio color={'secondary'} justify="start" key={2} labelPlacement="end" value='ONE-WAY'>
                                                            One-Way / Through-Hike<br />
                                                            <IonNote>Starts and ends at different trailheads</IonNote>
                                                        </IonRadio>
                                                    </IonItem>
                                                </IonCol>
                                            </IonRow>
                                        </IonRadioGroup>
                                    </IonCol> 
                                </IonRow>

                                <IonRow>
                                    <IonCol size='12'>
                                        <IonLabel color={'dark'}><b>Starting & Ending Trailheads</b> <em className='required'>Required</em></IonLabel>
                                    </IonCol>
                                </IonRow>

                                <IonRow> 
                                    <IonCol size='12' sizeSm='6'> 
                                        
                                        <IonSelect
                                          className='ion-margin-bottom ion-margin-top'
                                          fill='outline' 
                                          label='Starting Trailhead' 
                                          labelPlacement='stacked' 
                                          name='routeStartPlace' 
                                          onIonChange={syncEndPlace} 
                                          placeholder='Select a saved Place' 
                                          ref={startPlaceRef}
                                          value={startPlaceTokenVal}>
                                            <IonSelectOption value={null}>None</IonSelectOption>
                                            {startPlaces
                                                .filter((p: any) => p.placeSaved == '1')
                                                .map((place:any, index:number) => (
                                                <IonSelectOption key={index} value={place.placeToken}>{place.placeName}</IonSelectOption>
                                            ))}                                            
                                        </IonSelect> 
                                        {profiles?.places < limits?.places && newStartPlaceIsAvailable && !startPlaceTokenVal &&
                                        <>                                           
                                            <p className='ion-text-center'>- OR -</p>
                                            <IonCard>
                                                <IonCardHeader className='ion-text-center'>
                                                    <IonText className='cursor-pointer' color={'secondary'} onClick={openNewStartPlaceModal}><IonIcon icon={add}></IonIcon> ADD a New Starting Trailhead</IonText>
                                                </IonCardHeader>
                                                {newStartPlaceIsOpen &&
                                                <IonCardContent>
                                                    <IonGrid>
                                                        <IonRow>
                                                            <IonCol size='12'>
                                                                <IonLabel color={'dark'}><b>Starting Trailhead Name</b> <em className='required'>Required</em></IonLabel>
                                                            </IonCol>
                                                            <IonCol size='12'>
                                                                <IonInput autoCapitalize='sentences' className='ion-margin-bottom' fill='outline' name='startPlaceName' placeholder='' type='text' maxlength={50}></IonInput>                                        
                                                            </IonCol>                                  
                                                        </IonRow> 

                                                        <IonRow>
                                                            <IonCol size='12'>
                                                                <IonLabel color={'dark'}><b>Location</b> <em className='required'>Required</em></IonLabel><br />
                                                                <IonNote>Include the nearest town, road, and wilderness area (i.e. State Park, National Forest, etc.)</IonNote>
                                                            </IonCol>
                                                            <IonCol size='12'>
                                                                <IonInput autoCapitalize='sentences' className='ion-margin-bottom' fill='outline' name='startPlaceLocation' placeholder='' type='text' maxlength={200}></IonInput>                                        
                                                            </IonCol>                                  
                                                        </IonRow> 

                                                        <IonRow className='ion-margin-bottom'>
                                                            <IonCol size='12'>
                                                                <IonLabel color={'dark'}><b>Timezone</b></IonLabel> <em className='required'>Required</em><br />
                                                                <IonSelect fill='outline' labelPlacement='stacked' name='startPlaceTimezone' placeholder='Select a Timezone' value={userIANATimezone}>
                                                                    {timezonesIANA.map((zone: any, index: number) => (
                                                                        <IonSelectOption key={index} value={zone['iana']}>{zone['label']}</IonSelectOption>
                                                                    ))}                                            
                                                                </IonSelect>
                                                            </IonCol>
                                                        </IonRow> 

                                                        <IonRow className='ion-margin-bottom'>
                                                            <IonCol size='12'>
                                                                <IonLabel color={'dark'}><b>Local Emergency Response Agencies</b></IonLabel><br />
                                                                <IonNote>Include the name and phone number of the agencies your emergency contact(s) should call. This could be the local police, search and rescue team, etc.</IonNote>
                                                            </IonCol>
                                                            <IonCol size='12'>
                                                                <IonTextarea autoGrow={true} fill='outline' name='startPlaceNotes' placeholder=''></IonTextarea>                               
                                                            </IonCol>
                                                        </IonRow>
                                                    </IonGrid>
                                                </IonCardContent>   
                                                }                                            
                                            </IonCard>
                                        </> 
                                        }                                                      
                                    </IonCol>

                                    <IonCol size='12' sizeSm='6'> 
                                        <IonSelect
                                          className='ion-margin-bottom ion-margin-top'
                                          disabled={endPlaceDisabled} 
                                          fill='outline' 
                                          label='Ending Trailhead' 
                                          labelPlacement='stacked' 
                                          name='routeEndPlace' 
                                          onIonChange={handleEndPlaceChange} 
                                          placeholder={routeType === 'LOOP' ? 'Same as start' : 'Select a saved Place'} 
                                          ref={endPlaceRef}
                                          value={endPlaceTokenVal}>
                                            <IonSelectOption value={null}>None</IonSelectOption>
                                            {endPlaces
                                                .filter((p: any) => p.placeSaved == '1')
                                                .map((place:any, index:number) => (
                                                <IonSelectOption key={index} value={place.placeToken}>{place.placeName}</IonSelectOption>                                             
                                            ))}                                            
                                        </IonSelect>  
                                        {profiles?.places < limits?.places && routeType === 'ONE-WAY' && newEndPlaceIsAvailable && !endPlaceTokenVal &&
                                        <>
                                           <p className='ion-text-center'>- OR -</p>
                                            <IonCard>
                                                <IonCardHeader className='ion-text-center'>
                                                    <IonText className='cursor-pointer' color={'secondary'} onClick={openNewEndPlaceModal}><IonIcon icon={add}></IonIcon> ADD a New Ending Trailhead</IonText>
                                                </IonCardHeader>
                                                {newEndPlaceIsOpen &&
                                                <IonCardContent>
                                                    <IonGrid>
                                                        <IonRow>
                                                            <IonCol size='12'>
                                                                <IonLabel color={'dark'}><b>Ending Trailhead Name</b> <em className='required'>Required</em></IonLabel>
                                                            </IonCol>
                                                            <IonCol size='12'>
                                                                <IonInput autoCapitalize='sentences' className='ion-margin-bottom' fill='outline' name='endPlaceName' placeholder='' type='text' maxlength={50}></IonInput>                                        
                                                            </IonCol>                                  
                                                        </IonRow> 

                                                        <IonRow>
                                                            <IonCol size='12'>
                                                                <IonLabel color={'dark'}><b>Location</b> <em className='required'>Required</em></IonLabel><br />
                                                                <IonNote>Include the nearest town, road, and wilderness area (i.e. State Park, National Forest, etc.)</IonNote>
                                                            </IonCol>
                                                            <IonCol size='12'>
                                                                <IonInput autoCapitalize='sentences' className='ion-margin-bottom' fill='outline' name='endPlaceLocation' placeholder='' type='text' maxlength={200}></IonInput>                                        
                                                            </IonCol>                                  
                                                        </IonRow> 

                                                        <IonRow className='ion-margin-bottom'>
                                                            <IonCol size='12'>
                                                                <IonLabel color={'dark'}><b>Timezone</b></IonLabel> <em className='required'>Required</em><br />
                                                                <IonSelect fill='outline' labelPlacement='stacked' name='endPlaceTimezone' placeholder='Select a Timezone' value={userIANATimezone}>
                                                                    {timezonesIANA.map((zone: any, index: number) => (
                                                                        <IonSelectOption key={index} value={zone['iana']}>{zone['label']}</IonSelectOption>
                                                                    ))}                                            
                                                                </IonSelect>
                                                            </IonCol>
                                                        </IonRow> 

                                                        <IonRow className='ion-margin-bottom'>
                                                            <IonCol size='12'>
                                                                <IonLabel color={'dark'}><b>Local Emergency Response Agencies</b></IonLabel><br />
                                                                <IonNote>Include the name and phone number of the agencies your emergency contact(s) should call. This could be the local police, search and rescue team, etc.</IonNote>
                                                            </IonCol>
                                                            <IonCol size='12'>
                                                                <IonTextarea autoGrow={true} fill='outline' name='endPlaceNotes' placeholder=''></IonTextarea>                               
                                                            </IonCol>
                                                        </IonRow>
                                                    </IonGrid>
                                                </IonCardContent> 
                                                }                                             
                                            </IonCard>                                            
                                        </>
                                        }                    
                                    </IonCol>
                                </IonRow>

                                <IonRow>
                                    <IonCol size='12'>
                                        <IonLabel color={'dark'}><b>Approximate Distance</b></IonLabel>
                                    </IonCol>
                                    <IonCol size='6' sizeSm='3'>
                                        <IonInput fill='outline' name='routeDistance' placeholder='Distance' type='number' step='.1'></IonInput>
                                    </IonCol>
                                    <IonCol size='6' sizeSm='3'>
                                        <IonSelect fill='outline' label='Units' labelPlacement='stacked' name='routeDistanceUnits' placeholder='Units' value={'MI'}>  
                                            <IonSelectOption value='MI'>MI</IonSelectOption>
                                            <IonSelectOption value='KM'>KM</IonSelectOption>
                                        </IonSelect>
                                    </IonCol>  
                                    <IonCol sizeXs='12' sizeSm='6'>
                                        <IonSelect className='ion-margin-bottom' fill='outline' label='Travel Modes' labelPlacement='stacked' name='routeCategory' multiple={true} placeholder='You can select multiple '>
                                            <IonSelectOption value='1'>Hiking/Backpacking</IonSelectOption>
                                            <IonSelectOption value='2'>Horseback Riding</IonSelectOption>
                                            <IonSelectOption value='3'>Moto Riding</IonSelectOption>
                                            <IonSelectOption value='4'>Mtn Biking</IonSelectOption>
                                            <IonSelectOption value='5'>Trail Running</IonSelectOption>
                                        </IonSelect>
                                    </IonCol>                                 
                                </IonRow>

                                <IonRow>
                                    <IonCol size='12'>
                                        <IonLabel color={'dark'}><b>Destination, Waypoints & Campsites</b></IonLabel><br />
                                        <IonNote>This can be a list of points or landmarks along this Trail, such as a peak, a lake, etc.</IonNote>
                                    </IonCol>
                                    <IonCol size='12'>
                                        <IonTextarea autoCapitalize='sentences' autoGrow={true} fill='outline' name='routeWaypoints' placeholder=''></IonTextarea>                              
                                    </IonCol>
                                </IonRow>

                                <IonRow>
                                    <IonCol size='12'>
                                        <IonLabel color={'dark'}><b>Additional Information</b></IonLabel><br />
                                        <IonNote>This can be any other important information or links about this Trail.</IonNote>
                                    </IonCol>
                                    <IonCol size='12'>
                                        <IonTextarea autoCapitalize='sentences' autoGrow={true} fill='outline' name='routeNotes' placeholder=''></IonTextarea>                               
                                    </IonCol>
                                </IonRow>

                            </IonGrid>
                            
                            <IonButton className='ion-margin-top' color={'secondary'} expand="block" id='routeFormSubmit' type='submit'>Save</IonButton>
                        </form>
                    </IonCardContent>
                </IonCard>
                }
                
            </IonContent>
        </IonPage>
    );
};

export default TrailCreate;